import { render, staticRenderFns } from "./BtnShareStore.vue?vue&type=template&id=3538adb4&"
import script from "./BtnShareStore.vue?vue&type=script&lang=js&"
export * from "./BtnShareStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports